import { createElementBlock as o, openBlock as a, normalizeClass as r, createVNode as c, unref as d } from "vue";
import { themeProp as l } from "../../composables/useTheme.js";
/* empty css                        */
import s from "../../_virtual/_plugin-vue_export-helper.js";
import t from "../../atoms/icon-loader/icon-loader.vue.js";
const p = "DsPlaceholderLoader", m = /* @__PURE__ */ Object.assign({
  name: p
}, {
  __name: "placeholder-loader",
  props: {
    ...l
  },
  setup(n) {
    return (e, _) => (a(), o("div", {
      class: r(["ds-placeholder-loader", `ds-placeholder-loader--${e.theme}`]),
      "data-j-loader": ""
    }, [
      c(d(t), {
        class: "ds-placeholder-loader__icon",
        "data-j-icon": ""
      })
    ], 2));
  }
}), D = /* @__PURE__ */ s(m, [["__scopeId", "data-v-81a99da3"]]);
export {
  D as default
};
